import { Grid, useMediaQuery, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'

import { AccountSubscriptionBanner, JourneyIframe, LowWalletBalanceBanner } from 'src/components'
import { Navbar } from '../../navbar'
import { INavBarData } from 'src/types'

import useStyles from './styles'

interface ISharedLayoutProps {
  navbarData: INavBarData[]
}

const SharedLayout = ({ navbarData }: ISharedLayoutProps) => {
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))
  const classes = useStyles()

  return (
    <>
      <Grid container columnSpacing={isLaptop ? 0 : 2} className={classes.container}>
        <Grid className={classes.navbarWrapper} item>
          <Navbar navbarData={navbarData} />
        </Grid>
        <Grid className={classes.contentWrapper}>
          <LowWalletBalanceBanner />
          <AccountSubscriptionBanner />

          <Grid className={classes.innerContentWrapper}>
            <Outlet />
          </Grid>
        </Grid>
      </Grid>
      <JourneyIframe />
    </>
  )
}

export { SharedLayout }
